/* eslint-disable react-hooks/exhaustive-deps */
import { Flex, Icon, InputAdornment, InputControl } from '@tonic-one/react';
import { CloseIcon, SearchOIcon } from '@tonic-one/react-icons';
import React from 'react';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import { useFlexContainerStyle } from './style';

export const FlexContainer = React.memo(
  ({ style, ...props }: { [key: string]: any }) => {
    // console.log(style);
    useWhyDidYouUpdate('CasTreeTransfer FlexContainer', { style, ...props });
    const flexListStyle = useFlexContainerStyle();
    const newStyle = { ...flexListStyle, ...style };
    return <Flex style={newStyle} {...props} />;
  }
);

export const SearchInput = React.memo(
  ({ onChange, onSearch, value, autoClear, ...restProps }: any) => {
    const [inputValue, setInputValue] = React.useState<string>(value);
    useWhyDidYouUpdate('SearchInput', {
      onChange,
      onSearch,
      value,
      autoClear,
      ...restProps,
      inputValue,
    });
    React.useEffect(() => {
      if (value !== inputValue) {
        setInputValue(value);
      }
    }, [value]);
    const hanldleInputChange = React.useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
        onChange(e);
      },
      [onChange]
    );
    const handleKeyPress = React.useCallback(
      (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && onSearch) {
          onSearch(inputValue);
        }
      },
      [inputValue, onSearch]
    );
    const handleClear = React.useCallback(() => {
      setInputValue('');
      onChange({ target: { value: '' } });
      onSearch('');
    }, [onSearch]);

    return (
      <InputControl
        placeholder="Search"
        variant="outline"
        startAdornment={
          <InputAdornment>
            <Icon as={SearchOIcon} />
          </InputAdornment>
        }
        endAdornment={
          autoClear && inputValue.length ? (
            <InputAdornment>
              <Icon as={CloseIcon} onClick={handleClear} />
            </InputAdornment>
          ) : null
        }
        value={inputValue}
        onChange={hanldleInputChange}
        onKeyPress={handleKeyPress}
        {...restProps}
      ></InputControl>
    );
  }
);
